export const generateGlobalSettingDefaultData = (data) => {
    let defaultData = [];
    data.map((metric) => {
        defaultData = { ...defaultData, [metric.name]: metric.default_value }
    })
    return defaultData;
}